import { ZipRange } from '@tourfold/libraries/tf-api-client-public-v2';

export interface AreaFormResult {
  readonly name: string;
  readonly description: string | null;
  readonly color: string | null;
  readonly zipRanges: ZipRange[];
  readonly geoJson: object;
}

export interface AreaFormModel {
  name: string;
  description: string;
  color: string;
  zipRanges: ZipRange[];
}

export const PRESET_COLORS: readonly string[] = [
  '#2563EB',
  '#0EA5A4',
  '#F59E0B',
  '#A855F7',
  '#22C55E',
  '#EF4444',
  '#06B6D4',
  '#64748B',
];

export const DEFAULT_AREA_COLOR = '#2563EB';

export const MAX_AREA_NAME_LENGTH = 80;
export const MAX_AREA_DESCRIPTION_LENGTH = 500;
export const MAX_AREA_UPLOAD_BYTES = 1024 * 1024;
